export const WordCompleterListType = {
  MATH: 0,
  PIXBLOCKS_PYTHON: 1,
};
